import { wsClient } from '@/plugins/axios'

export const healthRepository = {
  async serverVersion() {
    const { data } = await wsClient.get<{ version: string }>('/health')
    return data
  },
}
